import React from 'react';
import { FeeHifiIcon } from '@applyboard/ui-icons';
import { InfoBoxItem } from "../InfoBoxItem";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var AmountItem = function AmountItem(_ref) {
  var amountRange = _ref.amountRange;
  return _jsx(InfoBoxItem, {
    icon: _jsx(FeeHifiIcon, {
      contrast: "mid",
      intent: "secondary"
    }),
    label: "Amount",
    subLabel: amountRange
  });
};